import { render, staticRenderFns } from "./CategoryHeroBanner.vue?vue&type=template&id=73c3c50c&scoped=true&"
import script from "./CategoryHeroBanner.vue?vue&type=script&lang=ts&"
export * from "./CategoryHeroBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryHeroBanner.vue?vue&type=style&index=0&id=73c3c50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3c50c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
